import MixedBannerPage from './MixedBannerPage';
export default MixedBannerPage;